import { AsyncPipe, DatePipe, NgClass } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatTooltip, MatTooltipDefaultOptions } from "@angular/material/tooltip";
import { Data, NavigationStart, Router } from "@angular/router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Plugins } from "@capacitor/core";
import { AuthService } from "@core/auth.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { LoadingService } from "@core/loading.service";
import { IonicModule, ModalController, NavParams } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { BehaviorSubject, EMPTY, merge, Observable, of, Subject, Subscription, throwError, timer } from "rxjs";
import {
  catchError,
  defaultIfEmpty,
  distinctUntilChanged,
  filter,
  map,
  exhaustMap,
  switchMap,
  take,
  takeUntil,
  tap,
  timeout,
} from "rxjs/operators";
import { flipIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import {
  excelLabelForIndex,
} from "../utils/excel-line-keys.util";
import { FilePreviewComponent } from "src/app/components/file-upload/file-preview.component";
import { SelectedGoldRingLockedComponent } from "src/app/components/gold-ring-popup/selected-gold-ring-locked/selected-gold-ring-locked.component";
import { SelectedGoldRingLostComponent } from "src/app/components/gold-ring-popup/selected-gold-ring-lost/selected-gold-ring-lost.component";
import { WinMorePopupComponent } from "src/app/components/win-more-popup/win-more-popup.component";
import { ConfirmSelectedLuckyNumbersComponent } from "src/app/lucky-nos-popup/confirm-selected-lucky-numbers/confirm-selected-lucky-numbers.component";
import { SelectedLuckyNumbersLostComponent } from "src/app/lucky-nos-popup/selected-lucky-numbers-lost/selected-lucky-numbers-lost.component";
import { CustomDatePipe } from "src/app/pipe/custom.datepipe";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { PaymentLogService } from "src/app/services/payment-log.service";
import { PaymentService } from "src/app/services/payment.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { TrackedEventsService } from "src/app/services/tracked-events.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { DotFlashAnimationComponent } from "../../../components/dot-flash-animation/dot-flash-animation.component";
import { HeaderComponent } from "../../../components/header/header.component";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { GamesRepositoryService } from "../../games/games-repository.service";
import { StoreRepositoryService } from "../../store/store-repository.service";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { SyndicateTicketPreviewComponent } from "../syndicate-ticket-preview/syndicate-ticket-preview.component";
import { SyndicateTicketFetchService } from "../syndicate-ticket-fetch.service";
import {
  CREDIT_PURCHASE_SUCCESS_EVENT,
  POST_PURCHASE_SLOW_STATUS_MS,
  POST_PURCHASE_SUCCESS_LOADER_MAX_MS,
  SYNDICATE_JOIN_INITIATED_EVENT,
  SYNDICATE_JOIN_SUCCESS_EVENT,
  SYNDICATE_REQUEST_POLL_MAX_MS,
  autoNavigateDelayMs,
  buildPostPurchaseContextKey,
  claimAnalyticsEmitOnce,
  ensureJoinIdempotencyKey,
  isLoadingUiActive as isPostPurchaseLoadingUiActive,
  isProceedClaimedForContext,
  markJoinCompletedForContext,
  postPurchaseLoaderHardCapMs,
  releaseAnalyticsEmitClaim,
  releaseJoinEndpointClaim,
  shouldEmitCreditPurchaseSuccess,
  shouldShowProceedCta as shouldShowPostPurchaseProceedCta,
  tryClaimJoinEndpointGuard,
  tryClaimProceedSlot,
} from "./syndicate-tickets-post-purchase.logic";

const { Browser } = Plugins;
const isEmpty = (val: Data) => val === undefined || val === null || !(Object.keys(val) || val).length;

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 10000000,
  touchendHideDelay: 100000,
};

@Component({
  selector: "app-syndicate-tickets",
  templateUrl: "./syndicate-tickets.component.html",
  styleUrls: ["./syndicate-tickets.component.scss"],
  animations: [flipIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    HeaderComponent,
    IonicModule,
    MatIcon,
    MatTooltip,
    NgClass,
    SwiperModule,
    LottieComponent,
    DotFlashAnimationComponent,
    InProgressAnimationComponent,
    MatProgressBar,
    AsyncPipe,
    DatePipe,
    TranslatePipe,
  ],
  providers: [SyndicateTicketFetchService]
})
export class SyndicateTicketsComponent implements OnInit, AfterViewInit, OnDestroy {
  options: AnimationOptions = {
    path: "./../../../../assets/slide-up.json",
    loop: 1,
  };
  loaderOptions: AnimationOptions = {
    path: "./../../../../assets/ticket-loading.json",
    loop: true,
  };
  showAnim = signal<boolean>(false);
  @ViewChild(FilePreviewComponent, { static: false }) filePreview: FilePreviewComponent;
  @ViewChild(MatTooltip) startip;
  @ViewChild("syndicateTicketsSlider") syndicateTicketsSlider: SwiperComponent;
  @Input() syndicateObj: Data;
  toolTipstar = "Select your Lucky Numbers below and win entry to our Prize Draw!";
  toolTipuparrow = "Select a Gold Ring and boost your chances of winning";
  showSlides: boolean;
  pageTitle;
  navigationSpeed: number;
  progressSignal = signal(0);
  ticketSlider: SwiperOptions = {
    speed: 400,
    initialSlide: 0,
    centeredSlides: true,
    slidesPerView: 1.15,
    pagination: {
      el: ".swiper-pager",
      clickable: true,
    },
  };
  createSyndicate = false;
  ticketChecked = false;
  ticketData: Data;
  ticketImageURL = "";
  viewTicket = false;
  ticketToBeChecked = false;
  checkedTicket = false;
  showLines = true;
  dotAnimation = false;
  showFlip: string = "";
  viewText = true;
  ticketManaged = false;
  syndicateTicketSource: string;
  syndicateDetails;
  syndicateCount: string;
  luckyNumbersEnabledData: Data;
  displayRemainingData: number;
  inUseCount: number;
  selectedNumbers: Data;
  totalSelectedCount: number = 0;
  clickAction: string;
  specialFeatureDisplay = false;
  disabledLNStyle: string = "";
  selectedNumbersAlready: Data;
  remainingData: Data;
  luckyNumberFeatureDisplay = false;
  isToolTipOpened: boolean = false;
  showStatusCard: boolean = false;
  translatedToastMsg: Data;
  languageCode: string = CommonVariable.preferredLanguage;
  luckyNumberStatusCards: Data;
  applyLuckyNumber: string;
  confirmLuckyNumber: string;
  placeLuckyCard: string;
  remaining: string;
  realname: string;
  doneButton: string;
  luckyNumberTooltip: string;
  showLoader =  signal(false);
  showTimerError = false;
  /** Shown when post-purchase loader hits the 2s hard cap (or status stays slow); exclusive with loader. */
  showAlmostThere = false;
  /** Fallback copy — remote i18n may not include syndicate-loading.almost-there yet. */
  almostThereText =
    "Almost there… Your purchase succeeded. You can Proceed while we finish loading your tickets.";
  progress = 0;
  dataFetched = false;
  showProgressBar = false;
  digitZero = 0;
  digitHundred = 100;
  digitTwo = 20;
  digitThousand = 1000;
  /** Overall max wait while polling syndicate/payment status (50s). */
  private readonly syndicateRequestPollMaxMs = SYNDICATE_REQUEST_POLL_MAX_MS;
  /** Documented slow-status SLA (>5s). Loader itself hard-caps earlier at successLoaderMaxMs. */
  private readonly slowStatusMs = POST_PURCHASE_SLOW_STATUS_MS;
  /**
   * Hard wall-clock cap for the post-purchase success loader (AC ≤2s).
   * Also bounds the short paint → auto-nav delay after tickets-ready.
   */
  private readonly successLoaderMaxMs = POST_PURCHASE_SUCCESS_LOADER_MAX_MS;
  private postPurchaseSlowTimerId: ReturnType<typeof setTimeout> | null = null;
  private progressIntervalId: ReturnType<typeof setInterval> | null = null;
  private progressCompleteTimerId: ReturnType<typeof setTimeout> | null = null;
  private autoNavigateTimerId: ReturnType<typeof setTimeout> | null = null;
  /** Frontend + session idempotency: block repeat Proceed / auto-nav. */
  proceedNavigating = false;
  private hasAutoNavigated = false;
  /** Stable join idempotency key for this purchase context (sent with join-related work). */
  private joinIdempotencyKey: string | null = null;
  private postPurchaseCelebrationEmitted = false;
  isSalesJourney = false;
  displayGoldRingRemainingData: number;
  goldRingInUseCount: number;
  goldRingRemainingData: number;
  selectedGoldRingLines: Data;
  totalGoldRingSelectedCount = 0;
  disabledGRStyle = "";
  goldRingFeatureDisplay = false;
  showGrStatusCard: boolean = false;
  goldRingStatusCards: Data;
  applyGoldRing: string;
  confirmGoldRing: string;
  confirmBtn: string;
  goldRingToolTip: string;
  selectedGRAry = {};
  alreadySelectedGRLines: Data;
  grDrawDate = {};
  syndicate_name = signal("");
  public showToolTip = false;
  public setDataSignal = signal(false);
  public months: string[] = [];
  public coachMarkData$ = new BehaviorSubject({});
  public timer = 3000;
  private isCashPurchase = false;
  private isAddCardCashPurchase = false;
  private isDestroyed = false;
  private globalProsubSubscription: Subscription;
  private globalProsubData: Data;
  private customerPurchaseSubscription: Subscription;
  private addCardCustomerPurchaseSubscription: Subscription;
  private ticketViewUpdateSubscription: Subscription;
  private addonAppendSubscription: Subscription;
  private unsubscribe$ = new Subject<void>();
  public WinMoreStatus: boolean;
  private baseOfferTicketGenerated = false;
  private postPaymentRedirected = false;
  private ticketRedirectRecovery?: Subscription;
  /** The overlay and every delayed ticket result belong to this authenticated user. */
  private ticketOwnerUserId: string | null = null;
  private ticketOwnerLost = false;
  private ticketOwnerAuthUnsubscribe?: () => void;
  /** Add-on/upsell CP ids discovered on the purchase doc within the shared deadline. */
  private expectedAddonCpIds = new Set<string>();
  private loadedAddonCpIds = new Set<string>();
  private loadingAddonCpIds = new Set<string>();
  private syndicateWinMoreData: Data;
  private iswinMoreDataFetched: boolean;
  private postPaymentCustomerPurchaseId: string;
  userId: string;
  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
    private authService: AuthService,
    private translate: TranslateService,
    public datepipe: CustomDatePipe,
    private trackedEventsService: TrackedEventsService,
    private GTMSegment: GTMSegmentService,
    private luckyNumberService: LuckyNumberService,
    private matDialog: MatDialog,
    private loadingService: LoadingService,
    private storeService: StoreRepositoryService,
    private paymentService: PaymentService,
    private paymentLogService: PaymentLogService,
    private changeDetectorRef: ChangeDetectorRef,
    private jackpotTriggerService: JackpotTriggersService,
    private ngZone: NgZone,
    private gameRepoService: GamesRepositoryService,
    private elRef: ElementRef,
    private bottomSheet: MatBottomSheet,
    private syndicateDataService: SyndicateDataService,
    private AuthPartialRegService: AuthPartialRegService,
    private ticketFetchService: SyndicateTicketFetchService
  ) {
    const syndicate = this.navParams.get("syndicate");
    const isPostPaymentLoad =
      (this.navParams.get("isSalesJourney") ||
        this.navParams.get("isCashPurchase") ||
        this.navParams.get("isAddCardCashPurchase")) &&
      (syndicate?.syndicate_id === null || !syndicate?.syndicate_id);

    if (isPostPaymentLoad) {
      this.showLoader.set(true);
    }

    this.navigationSpeed = 500;
    try {
      this.GTMSegment.GTMPopupInitialization("SyndicateTicket");
      this.authService.getConstantsMsg$?.pipe(takeUntil(this.unsubscribe$)).subscribe((msg: Data) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      });
      this.authService?.userDetails$?.pipe(takeUntil(this.unsubscribe$)).subscribe((user: Data) => {
        this.languageCode = user?.language_code ?? CommonVariable.preferredLanguage;
        translate.use(this.languageCode ? this.languageCode : CommonVariable.preferredLanguage);
        this.getMonths();
        this.resolveAlmostThereText();
      });

      this.globalProsubSubscription = this.GTMSegment?.getGlobalProsub()
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: Data) => {
          this.globalProsubData = res;
        });
    } catch (e) {
      return e;
    }
    // Get win more value
    this.syndicateDataService
      .GetWinMorePromise()
      .pipe(
        catchError((err) => {
          return of(null);
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res: Data) => {
        try {
          this.WinMoreStatus = res?.win_more_promise;
        } catch (err) {
          return err;
        }
      });

    // This method has been used to get win more details
    this.syndicateDataService
      .getWinMoreDetails()
      .pipe(
        catchError((err) => throwError(err)),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res: Data) => {
        try {
          this.syndicateWinMoreData = res;
          this.iswinMoreDataFetched = res[0]?.win_more_promise_details ? true : false;
          this.setSyndicateNameFromDetails();
        } catch (err) {
          return new Error("Win more details not found");
        }
      });
  }
  async ngAfterViewInit(): Promise<void> {
    await setTimeout(() => {
      this.showAnim.set(true);
    }, 1000);
    setTimeout(() => {
      if (!this.goldRingFeatureDisplay && this.goldRingRemainingData) {
        this.showGrToolTip();
      }
    }, 2000);
  }
  private setSyndicateNameFromDetails(): void {
    const name = this.syndicateDetails?.syndicate_name ?? this.syndicateDetails?.ps_name;
    if (name) {
      this.syndicate_name.set(name);
    }
  }

  private loadSyndicateNameFromId(encryptSyndicateId: string): void {
    if (!this.isTicketOwnerCurrent() || !encryptSyndicateId) {
      return;
    }
    this.paymentService
      .getSyndicateInfoWithProducts(encryptSyndicateId)
      .pipe(take(1), takeUntil(this.unsubscribe$))
      .subscribe({
        next: (detail: Data) => {
          if (!this.isTicketOwnerCurrent()) return;
          const info = detail?.[0]?.data?.();
          const name = info?.syndicate_name ?? info?.ps_name;
          if (name) {
            this.applySyndicateNameToProducts(encryptSyndicateId, name);
            this.updateSyndicateNameForActiveSlide(name, encryptSyndicateId);
          }
        },
        error: (err) => {
          this.authService.errorHandlerLogs("Error fetching syndicate name for ticket:", err);
        },
      });
  }

  private applySyndicateNameToProducts(encryptSyndicateId: string, name: string): void {
    this.ticketData?.product?.forEach((product: Data) => {
      if (product?.encrypt_syndicate_id === encryptSyndicateId) {
        product.syndicate_name = name;
      }
    });
  }

  private updateSyndicateNameForActiveSlide(
    fallbackName?: string,
    fallbackSyndicateId?: string
  ): void {
    const activeIndex = this.syndicateTicketsSlider?.swiperRef?.activeIndex ?? 0;
    const ticket = this.ticketData?.product?.[activeIndex];
    const activeSyndicateId = ticket?.encrypt_syndicate_id;

    if (
      fallbackSyndicateId &&
      activeSyndicateId &&
      activeSyndicateId !== fallbackSyndicateId
    ) {
      return;
    }

    const name = ticket?.syndicate_name ?? fallbackName;
    if (name) {
      this.syndicate_name.set(name);
      this.changeDetectorRef.markForCheck();
      return;
    }

    const syndicateId = activeSyndicateId ?? fallbackSyndicateId;
    if (syndicateId) {
      this.loadSyndicateNameFromId(syndicateId);
    }
  }

  private onTicketDataLoaded(): void {
    this.updateSyndicateNameForActiveSlide();
  }

  /** New-card / sales-journey: syndicate id may already be on PaymentService before polling. */
  private loadPurchasedSyndicateNameIfAvailable(): void {
    const fromSql = this.paymentService.salesJournyPaymentDetails$.getValue();
    const fromAddCard = this.paymentService.cashPurchaseAddCardSyndicateId$.getValue();
    if (fromSql) {
      this.loadSyndicateNameFromId(fromSql);
    } else if (fromAddCard) {
      this.loadSyndicateNameFromId(fromAddCard);
    }
  }

  async ngOnInit() {
    if (!this.bindTicketOwner()) return;
    this.selectedNumbers = this.ticketFetchService.selectedNumbers;
    this.selectedNumbersAlready = this.ticketFetchService.selectedNumbersAlready;
    this.selectedGoldRingLines = this.ticketFetchService.selectedGoldRingLines;
    this.alreadySelectedGRLines = this.ticketFetchService.alreadySelectedGRLines;
    this.realname = this.ticketFetchService.realname;
    this.resolveAlmostThereText();
    await this.authService
      ?.getUid("SyndicateTicketsComponent")
      ?.then((uid) => {
        if (this.isTicketOwnerCurrent() && uid === this.ticketOwnerUserId) this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    // getUid may resolve after logout/account replacement or overlay teardown.
    if (!this.isTicketOwnerCurrent() || this.userId !== this.ticketOwnerUserId) return;
    try {
      this.luckyNumberService
        .getLuckyNumbersEnabled()
        ?.pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (ref) => {
            this.luckyNumbersEnabledData = ref as Data;
            if (this.luckyNumbersEnabledData?.lucky_numbers === true) {
              this.luckyNumberService
                .getUserCurrentBalance()
                ?.pipe(takeUntil(this.unsubscribe$))
                .subscribe((ref: Data) => {
                  this.displayRemainingData = ref?.lucky_numbers?.remaining;
                  this.remainingData = ref?.lucky_numbers?.remaining;
                  this.inUseCount = ref?.lucky_numbers?.in_use;
                });
              this.clickAction = this.syndicateDetails?.click_action;

              if (this.clickAction === "lnWithOutStar") {
                this.specialFeatureDisplay = true;
                this.luckyNumberFeatureDisplay = true;
                this.showStatusCard = true;
              } else if (this.clickAction === "lnWithStar") {
                this.specialFeatureDisplay = true;
                this.luckyNumberFeatureDisplay = true;
                this.showStatusCard = true;
              } else if (this.clickAction === "viewTickets") {
                this.specialFeatureDisplay = this.luckyNumbersEnabledData?.lucky_numbers ? true : false; //viewTickets and tooltip logic
                this.luckyNumberFeatureDisplay = false;
                this.showStatusCard = false;
              }
            }

            if (this.luckyNumbersEnabledData?.gold_rings === true) {
              this.luckyNumberService
                .getUserCurrentBalance()
                ?.pipe(takeUntil(this.unsubscribe$))
                .subscribe((ref: Data) => {
                  this.displayGoldRingRemainingData = ref?.gold_rings?.remaining;
                  this.goldRingInUseCount = ref?.gold_rings?.in_use;
                  this.goldRingRemainingData = ref?.gold_rings?.remaining;
                });
              this.clickAction = this.syndicateDetails?.click_action;

              if (this.clickAction === "grWithOutArrow") {
                this.showGrStatusCard = true;
                this.goldRingFeatureDisplay = true;
              } else if (this.clickAction === "grWithArrow") {
                this.showGrStatusCard = true;
                this.goldRingFeatureDisplay = true;
              } else if (this.clickAction === "viewTickets") {
                this.showGrStatusCard = false;
                this.goldRingFeatureDisplay = false;
              }
            }
          },
          (error) => {
            return error;
          }
        );
      this.luckyNumberService.selectedLnSaved?.pipe(takeUntil(this.unsubscribe$)).subscribe((msg) => {
        if (msg) this.totalSelectedCount = 0;
      });
      this.luckyNumberService.selectedGRSaved?.pipe(takeUntil(this.unsubscribe$)).subscribe((msg) => {
        if (msg) this.totalGoldRingSelectedCount = 0;
      });

      this.syndicateDetails = this.navParams.get("syndicate");
      this.syndicateTicketSource = this.navParams.get("source");
      this.isSalesJourney = this.navParams.get("isSalesJourney");
      this.isCashPurchase = this.navParams.get("isCashPurchase");
      this.isAddCardCashPurchase = this.navParams.get("isAddCardCashPurchase");
      this.setSyndicateNameFromDetails();

      if (this.isSalesJourney || this.isCashPurchase || this.isAddCardCashPurchase) {
        this.bindPostPaymentTicketDeadline();
      }

      if (
        this.syndicateTicketSource === "syndicateTab" ||
        this.isSalesJourney ||
        this.isCashPurchase ||
        this.isAddCardCashPurchase
      ) {
        this.paymentService.addOnOffersCustomerPurchaseIds$.next(null);
        this.ticketFetchService.resetAddonState();
        this.expectedAddonCpIds.clear();
        this.loadedAddonCpIds.clear();
        this.loadingAddonCpIds.clear();
        this.baseOfferTicketGenerated = false;
      }

      if (!this.syndicateObj) {
        this.syndicateObj = this.navParams.get("syndicateObj");
      }

      if (this.syndicateDetails?.syndicate_id === null || !this.syndicateDetails?.syndicate_id) {
        if (this.isSalesJourney || this.isCashPurchase || this.isAddCardCashPurchase) {
          this.loadPurchasedSyndicateNameIfAvailable();
          this.paymentService.salesJournyPaymentDetails$
            .pipe(filter((id) => !!id && id !== "0"), take(1), takeUntil(this.unsubscribe$))
            .subscribe((id) => this.loadSyndicateNameFromId(id));
          this.paymentService.cashPurchaseAddCardSyndicateId$
            .pipe(filter((id) => !!id && id !== "0"), take(1), takeUntil(this.unsubscribe$))
            .subscribe((id) => this.loadSyndicateNameFromId(id));
          this.beginPostPurchaseLoadingUi();

          const salesSyndicateId = this.paymentService.salesJournyPaymentDetails$.getValue();
          const addCardSyndicateId = this.paymentService.cashPurchaseAddCardSyndicateId$.getValue();
          const isValidImmediateId = (id: string | null | undefined): id is string =>
            !!id && id !== "0";
          const immediateSyndicateId = isValidImmediateId(salesSyndicateId)
            ? salesSyndicateId
            : isValidImmediateId(addCardSyndicateId)
              ? addCardSyndicateId
              : null;
          if (immediateSyndicateId) {
            // Same bounded listener path as async resolution — never one-shot empty products.
            this.applySyndicateTicketView(immediateSyndicateId);
            // Still track CP / add-on sources so upsells are not missed when base id was already known.
            this.trackCustomerPurchaseDocument();
            if (this.isAddCardCashPurchase && !this.getBaseCustomerPurchaseId()) {
              this.trackCustomerPurchaseDocumentFromAddCard();
            }
            return;
          }

          // Apply as soon as any syndicate id source emits (new-card SQL often lands here
          // before/without waiting on the CP doc listener alone).
          merge(
            this.paymentService.salesJournyPaymentDetails$,
            this.paymentService.cashPurchaseAddCardSyndicateId$
          )
            .pipe(
              filter((id): id is string => !!id && id !== "0"),
              take(1),
              takeUntil(this.unsubscribe$),
              catchError((err) => {
                this.authService.errorHandlerLogs(
                  "[syndicate-tickets] Error resolving syndicateId for ticket view:",
                  err
                );
                return EMPTY;
              })
            )
            .subscribe({
              next: (syndicateId) => {
                try {
                  this.applySyndicateTicketView(syndicateId);
                } catch (err) {
                  this.authService.errorHandlerLogs(
                    "[syndicate-tickets] Uncaught error in applySyndicateTicketView:",
                    err
                  );
                }
              },
            });

          // New-card sets both isSalesJourney and isAddCardCashPurchase. Track CP docs and
          // the add-card syndicate subject so we do not miss either source.
          this.trackCustomerPurchaseDocument();
          if (this.isAddCardCashPurchase && !this.getBaseCustomerPurchaseId()) {
            this.trackCustomerPurchaseDocumentFromAddCard();
          }
          return;
        }
        this.fetchTicketData();
        return;
      }
      this.getTicketData();
    } catch (e) {
      return e;
    }

    this.authService?.userDetails$?.pipe(takeUntil(this.unsubscribe$)).subscribe((user: Data) => {
      this.languageCode = user?.language_code ? user?.language_code : CommonVariable.preferredLanguage;
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe(
        (data) => {
          this.luckyNumberStatusCards = data?.["ln_status_in_tickets"];
          this.goldRingStatusCards = data?.["gold_ring_status_in_tickets"];
          this.applyLuckyNumber = this.luckyNumberStatusCards?.apply_lucky_number;
          this.confirmLuckyNumber = this.luckyNumberStatusCards?.confirm_lucky_number;
          this.placeLuckyCard = this.luckyNumberStatusCards?.place_lucky_card;
          this.remaining = this.luckyNumberStatusCards?.remaining;
          this.luckyNumberTooltip = this.luckyNumberStatusCards?.lucky_number_tooltip;
          this.doneButton = this.luckyNumberStatusCards?.done_button;
          this.goldRingToolTip = this.goldRingStatusCards?.gold_ring_tooltip;
          this.applyGoldRing = this.goldRingStatusCards?.apply_gold_ring;
          this.confirmGoldRing = this.goldRingStatusCards?.confirm_gold_ring;
          this.confirmBtn = this.goldRingStatusCards?.confirm_btn;
        },
        (err) => {
          return err;
        }
      );
    });
  }

  private bindTicketOwner(): boolean {
    if (this.ticketOwnerLost || this.isDestroyed) return false;
    const user = getAuth().currentUser;
    if (!user || user.isAnonymous) {
      this.releaseTicketOwner();
      return false;
    }
    this.ticketOwnerUserId = user.uid;
    const unsubscribe = onAuthStateChanged(getAuth(), (current) => {
      if (!current || current.isAnonymous || current.uid !== this.ticketOwnerUserId) this.releaseTicketOwner();
    }, () => this.releaseTicketOwner());
    if (this.ticketOwnerLost) unsubscribe();
    else this.ticketOwnerAuthUnsubscribe = unsubscribe;
    return !this.ticketOwnerLost;
  }

  private isTicketOwnerCurrent(): boolean {
    if (this.isDestroyed || this.ticketOwnerLost) return false;
    if (!this.ticketOwnerUserId) return false;
    const user = getAuth().currentUser;
    return !!user && !user.isAnonymous && user.uid === this.ticketOwnerUserId;
  }

  private releaseTicketOwner(): void {
    if (this.ticketOwnerLost) return;
    this.ticketOwnerLost = true;
    this.ticketOwnerAuthUnsubscribe?.();
    this.ticketOwnerAuthUnsubscribe = undefined;
    this.ticketRedirectRecovery?.unsubscribe();
    this.clearPostPurchaseSlowTimer();
    this.clearProgressInterval();
    this.clearProgressCompleteTimer();
    this.clearNavigationTimers();
    this.unsubscribe$.next();
    this.ticketData = null;
    this.showLoader.set(false);
    this.showProgressBar = false;
    // Remove this overlay immediately on owner loss; never dismiss a replacement modal.
    const ownModal = this.elRef?.nativeElement?.closest?.("ion-modal") as HTMLIonModalElement | undefined;
    if (ownModal) {
      try { void ownModal.dismiss().catch(() => undefined); } catch { /* Scoped removal still runs. */ }
      ownModal.remove();
    }
  }

  /** Prefer translated copy when present; never show the raw i18n key. */
  private resolveAlmostThereText(): void {
    const key = "syndicate-loading.almost-there";
    const fallback = this.almostThereText;
    this.translate
      .get(key)
      .pipe(take(1), takeUntil(this.unsubscribe$))
      .subscribe((value: string) => {
        if (value && value !== key) {
          this.almostThereText = value;
          this.changeDetectorRef.markForCheck();
        } else {
          this.almostThereText = fallback;
        }
      });
  }

  showGrToolTip() {
    const tooltipElement = this.elRef?.nativeElement?.querySelector(".gold-ring-wrapper .tooltip");
    if (tooltipElement) {
      this.showGrStatusCard = false;
      tooltipElement.style.display = "flex";
      setTimeout(() => {
        tooltipElement.style.display = "none";
      }, 2000);
    }
  }

  /** Credit purchase / sales / cash flows that must not hang on an indefinite spinner. */
  private isPostPurchaseFlow(): boolean {
    return !!(
      this.isSalesJourney ||
      this.isCashPurchase ||
      this.isAddCardCashPurchase ||
      this.syndicateObj ||
      this.navParams?.get?.("syndicateObj")
    );
  }

  /** True while an active loader or top progress bar is showing (CTA must stay hidden). */
  isLoadingUiActive(): boolean {
    return isPostPurchaseLoadingUiActive(this.showLoader(), this.showProgressBar);
  }

  /** Proceed / Back CTA visible only when not loading (exclusive with spinner/progress). */
  showProceedCta(): boolean {
    if (this.postPaymentRedirected) return false;
    return shouldShowPostPurchaseProceedCta({
      syndicateTicketSource: this.syndicateTicketSource,
      showLoader: this.showLoader(),
      showProgressBar: this.showProgressBar,
      dataFetched: this.dataFetched,
      showAlmostThere: this.showAlmostThere,
      showTimerError: this.showTimerError,
    });
  }

  private clearPostPurchaseSlowTimer(): void {
    if (this.postPurchaseSlowTimerId != null) {
      clearTimeout(this.postPurchaseSlowTimerId);
      this.postPurchaseSlowTimerId = null;
    }
  }

  private clearProgressInterval(): void {
    if (this.progressIntervalId != null) {
      clearInterval(this.progressIntervalId);
      this.progressIntervalId = null;
    }
  }

  private clearProgressCompleteTimer(): void {
    if (this.progressCompleteTimerId != null) {
      clearTimeout(this.progressCompleteTimerId);
      this.progressCompleteTimerId = null;
    }
  }

  /**
   * Generic overlay loader (no post-purchase "Almost there" copy).
   */
  private beginOverlayLoadingUi(): void {
    this.showAlmostThere = false;
    this.showTimerError = false;
    this.showLoader.set(true);
    this.clearPostPurchaseSlowTimer();
  }

  /**
   * Start post-purchase loader with a hard ≤2s cap (AC).
   * After successLoaderMaxMs without tickets: hide spinner/progress and show "Almost there..." + Proceed.
   * The 5s slow-status SLA remains documented via slowStatusMs; loader must not wait that long.
   */
  private beginPostPurchaseLoadingUi(): void {
    this.beginOverlayLoadingUi();
    this.ensurePostPurchaseJoinIdempotency();
    // Hard-cap at 2s; never wait for the slower 5s status SLA before clearing the spinner.
    const loaderCapMs = Math.min(
      postPurchaseLoaderHardCapMs(this.successLoaderMaxMs),
      this.slowStatusMs
    );
    this.postPurchaseSlowTimerId = setTimeout(() => {
      if (this.dataFetched || this.hasAutoNavigated || this.baseOfferTicketGenerated) {
        return;
      }
      this.clearProgressInterval();
      this.showProgressBar = false;
      this.showLoader.set(false);
      this.showAlmostThere = true;
      this.changeDetectorRef.detectChanges();
    }, loaderCapMs);
  }

  private getPostPurchaseSessionStorage(): Storage | null {
    try {
      return typeof sessionStorage !== "undefined" ? sessionStorage : null;
    } catch {
      return null;
    }
  }

  /**
   * Resolve join idempotency key for this purchase and restore Proceed/join guards after refresh.
   * Join already completed → no re-join; Proceed already claimed → keep CTA disabled.
   */
  private ensurePostPurchaseJoinIdempotency(): string {
    const contextKey = this.getPostPurchaseContextKey();
    const storage = this.getPostPurchaseSessionStorage();
    this.joinIdempotencyKey = ensureJoinIdempotencyKey(storage, contextKey);
    if (isProceedClaimedForContext(storage, contextKey)) {
      this.proceedNavigating = true;
      this.hasAutoNavigated = true;
    }
    return this.joinIdempotencyKey;
  }

  /**
   * Claim the join-endpoint guard for this purchase context (refresh / multi-click safe).
   * Returns the idempotency key that backend join handlers should treat as a no-op on repeat.
   */
  private claimJoinEndpointGuardForPurchase(): {
    claimed: boolean;
    idempotencyKey: string;
    alreadyCompleted: boolean;
  } {
    const contextKey = this.getPostPurchaseContextKey();
    const storage = this.getPostPurchaseSessionStorage();
    const result = tryClaimJoinEndpointGuard(storage, contextKey);
    this.joinIdempotencyKey = result.idempotencyKey;
    return result;
  }

  /**
   * Unlock the join-endpoint claim after FAILURE / TIMEOUT so refresh/retry can claim again.
   * Does not clear join-completed or the stable idempotency key.
   */
  private releaseJoinEndpointClaimForPurchase(): void {
    releaseJoinEndpointClaim(
      this.getPostPurchaseSessionStorage(),
      this.getPostPurchaseContextKey()
    );
  }

  private markPostPurchaseJoinCompleted(): void {
    const contextKey = this.getPostPurchaseContextKey();
    markJoinCompletedForContext(this.getPostPurchaseSessionStorage(), contextKey);
    this.joinIdempotencyKey = ensureJoinIdempotencyKey(
      this.getPostPurchaseSessionStorage(),
      contextKey
    );
  }

  private clearNavigationTimers(): void {
    if (this.autoNavigateTimerId != null) {
      clearTimeout(this.autoNavigateTimerId);
      this.autoNavigateTimerId = null;
    }
  }

  private clearLoadingUiForTerminalFailure(): void {
    this.clearPostPurchaseSlowTimer();
    this.clearProgressInterval();
    this.showProgressBar = false;
    this.showLoader.set(false);
    this.showAlmostThere = false;
  }

  /** Terminal UI when post-purchase polling fails or times out without tickets. */
  private enterPostPurchaseTerminalError(context: string, err?: unknown): void {
    if (!this.isTicketOwnerCurrent()) return;
    // Failure/timeout after claim — release before any early return so refresh/retry can claim again.
    // Safe when join already completed (does not clear completed / cached success / idempotency key).
    this.releaseJoinEndpointClaimForPurchase();
    if (this.isDestroyed || this.dataFetched || this.hasAutoNavigated || this.showTimerError) {
      return;
    }
    if (err !== undefined) {
      this.authService.errorHandlerLogs(context, err);
    } else {
      this.authService.errorHandlerLogs(context);
    }
    this.loadingService.dismiss();
    this.clearLoadingUiForTerminalFailure();
    this.showTimerError = true;
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Success path: dismiss loader immediately.
   * Pass autoNavigate: true for credit purchase flows that should skip a manual Proceed.
   */
  private onPostPurchaseTicketsReady(options?: { autoNavigate?: boolean }): void {
    if (!this.isTicketOwnerCurrent()) return;
    this.clearPostPurchaseSlowTimer();
    this.clearProgressInterval();
    this.showAlmostThere = false;
    this.showTimerError = false;
    this.showProgressBar = false;
    this.dataFetched = true;
    this.setDataSignal.set(true);
    this.showLoader.set(false);
    // Purchase/join succeeded for this context — refresh must not re-join/re-charge.
    this.markPostPurchaseJoinCompleted();
    this.onTicketDataLoaded();
    this.changeDetectorRef.detectChanges();
    if (
      shouldEmitCreditPurchaseSuccess({
        isPostPurchase: this.isPostPurchaseFlow(),
        isSalesJourney: !!this.isSalesJourney,
        isCashPurchase: !!this.isCashPurchase,
        isAddCardCashPurchase: !!this.isAddCardCashPurchase,
      })
    ) {
      this.emitNamedPostPurchaseEventOnce(CREDIT_PURCHASE_SUCCESS_EVENT);
    }

    if (options?.autoNavigate === true && this.syndicateTicketSource !== "syndicateTab") {
      this.scheduleAutoNavigateToSyndicate();
    }
  }

  private scheduleAutoNavigateToSyndicate(): void {
    if (!this.tryBeginProceedNavigation()) {
      return;
    }
    this.clearNavigationTimers();
    // Allow a short paint after loader dismiss; stay well under the 2s success-loader budget.
    this.autoNavigateTimerId = setTimeout(() => {
      this.autoNavigateTimerId = null;
      this.performProceedNavigation();
    }, autoNavigateDelayMs(this.successLoaderMaxMs));
  }

  private getPostPurchaseContextKey(): string {
    return buildPostPurchaseContextKey({
      customerPurchaseId: this.postPaymentCustomerPurchaseId,
      requestId: this.syndicateObj?.pwa_syndicate_request_id,
      encryptSyndicateId: this.syndicateObj?.encrypt_syndicate_id,
      encryptedId: this.syndicateDetails?.encrypted_id,
    });
  }

  /** Emit a named Segment event at most once per purchase context (incl. page refresh). */
  private emitNamedPostPurchaseEventOnce(eventName: string, body?: Data): void {
    if (!this.isPostPurchaseFlow()) {
      return;
    }
    const storage = this.getPostPurchaseSessionStorage();
    const contextKey = this.getPostPurchaseContextKey();
    if (!claimAnalyticsEmitOnce(storage, contextKey, eventName)) {
      return;
    }
    try {
      // Resolve key only — do not call ensurePostPurchaseJoinIdempotency() here
      // (that also restores Proceed/nav flags as a side effect of analytics).
      if (!this.joinIdempotencyKey) {
        this.joinIdempotencyKey = ensureJoinIdempotencyKey(storage, contextKey);
      }
      this.GTMSegment.trackEvent(eventName, {
        context_key: contextKey,
        idempotency_key: this.joinIdempotencyKey,
        source: "syndicate-tickets-post-purchase",
        ...(body || {}),
      });
    } catch (err) {
      // Failed track must not burn the once-only claim — retry can emit exactly once.
      releaseAnalyticsEmitClaim(storage, contextKey, eventName);
      this.authService.errorHandlerLogs(`[syndicate-tickets] ${eventName} analytics emit failed:`, err);
    }
  }

  private emitPostPurchaseAnalyticsOnce(): void {
    if (!this.isPostPurchaseFlow()) {
      return;
    }
    if (
      shouldEmitCreditPurchaseSuccess({
        isPostPurchase: true,
        isSalesJourney: !!this.isSalesJourney,
        isCashPurchase: !!this.isCashPurchase,
        isAddCardCashPurchase: !!this.isAddCardCashPurchase,
      })
    ) {
      this.emitNamedPostPurchaseEventOnce(CREDIT_PURCHASE_SUCCESS_EVENT);
    }
    this.emitNamedPostPurchaseEventOnce(SYNDICATE_JOIN_SUCCESS_EVENT);
    if (this.postPurchaseCelebrationEmitted) {
      return;
    }
    this.postPurchaseCelebrationEmitted = true;
    try {
      this.trackedEventsService.openAnimation();
    } catch (err) {
      this.authService.errorHandlerLogs("[syndicate-tickets] celebration analytics emit failed:", err);
    }
  }

  /** Claim the single Proceed / auto-nav slot (idempotent). Does not re-join or re-charge. */
  private tryBeginProceedNavigation(): boolean {
    if (!this.isTicketOwnerCurrent()) return false;
    const contextKey = this.getPostPurchaseContextKey();
    const storage = this.getPostPurchaseSessionStorage();
    // Join-endpoint guard: same purchase context → no-op (incl. refresh). Proceed never re-joins.
    const joinGuard = this.claimJoinEndpointGuardForPurchase();
    const claim = tryClaimProceedSlot(
      {
        proceedNavigating: this.proceedNavigating,
        hasAutoNavigated: this.hasAutoNavigated,
      },
      storage,
      contextKey
    );
    if (!claim.claimed) {
      // Proceed slot already taken — release a freshly acquired join claim so retries are not stuck.
      if (joinGuard.claimed) {
        this.releaseJoinEndpointClaimForPurchase();
      }
      return false;
    }
    // Only after a successful Proceed claim — payment already succeeded; durable no-op for refresh.
    this.markPostPurchaseJoinCompleted();
    this.proceedNavigating = claim.proceedNavigating;
    this.hasAutoNavigated = claim.hasAutoNavigated;
    this.clearPostPurchaseSlowTimer();
    this.showLoader.set(false);
    this.showProgressBar = false;
    this.showAlmostThere = false;
    // Join already completed at payment; mark initiated once when leaving this screen.
    this.emitNamedPostPurchaseEventOnce(SYNDICATE_JOIN_INITIATED_EVENT, {
      idempotency_key: joinGuard.idempotencyKey,
    });
    this.changeDetectorRef.detectChanges();
    return true;
  }

  private performProceedNavigation(): void {
    if (!this.isTicketOwnerCurrent()) return;
    const ownerUserId = this.ticketOwnerUserId;
    const ownerStillAuthenticated = () => {
      const current = getAuth().currentUser;
      return !!ownerUserId && current?.uid === ownerUserId && !current.isAnonymous;
    };
    // Capture redirect deps before dismiss — Ionic destroys this modal component on dismiss,
    // so a component-owned timeout cleared in ngOnDestroy would cancel the redirect.
    const router = this.router;
    const loadingService = this.loadingService;
    const delayMs = this.digitThousand;
    const defaultRedirectionLink = "/syndicate";
    const redirectionLink =
      this.globalProsubData?.post_store_sale_final_page?.[this.languageCode || "en"] || defaultRedirectionLink;

    this.modalCtrl
      .dismiss()
      .then(() => {
        if (!ownerStillAuthenticated()) return;
        this.emitPostPurchaseAnalyticsOnce();
        loadingService.present();
        this.clearNavigationTimers();
        setTimeout(() => {
          if (!ownerStillAuthenticated()) return;
          router.navigateByUrl(redirectionLink).catch(() => undefined);
          loadingService.dismiss();
        }, delayMs);
      })
      .catch((err) => {
        this.proceedNavigating = false;
        this.hasAutoNavigated = false;
        return err;
      });
  }

  enableProgressBar() {
    this.beginPostPurchaseLoadingUi();
    this.showProgressBar = true;
    this.progress = this.digitZero;
    this.progressSignal.set(this.progress);
    this.clearProgressInterval();

    // Advance the bar for feedback only; never dismiss loader without data (that caused the hang).
    this.progressIntervalId = setInterval(() => {
      if (this.setDataSignal() || this.dataFetched) {
        this.clearProgressInterval();
        this.completeProgressAnimation();
        return;
      }
      if (this.showAlmostThere || this.showTimerError) {
        this.clearProgressInterval();
        this.showProgressBar = false;
        this.changeDetectorRef.detectChanges();
        return;
      }
      if (this.progress < 90) {
        this.progress += 1;
        this.progressSignal.set(this.progress);
        this.changeDetectorRef.markForCheck();
      }
    }, this.digitThousand);
  }

  completeProgressAnimation() {
    this.clearProgressInterval();
    this.clearProgressCompleteTimer();
    this.progress = this.digitHundred;
    this.progressSignal.set(this.progress);
    this.changeDetectorRef.detectChanges();
    this.progressCompleteTimerId = setTimeout(() => {
      this.progressCompleteTimerId = null;
      if (this.isDestroyed) {
        return;
      }
      this.showProgressBar = false;
      // Only clear loader here when tickets are ready; otherwise slow-status UI owns the state.
      if (this.dataFetched || this.setDataSignal()) {
        this.showLoader.set(false);
      }
      this.changeDetectorRef.detectChanges();
    }, this.digitThousand);
  }


  fetchTicketData() {
    if (!this.isTicketOwnerCurrent()) return;
    this.dataFetched = false;
    this.enableProgressBar();
    // Claim join idempotency for this purchase before any status/join-related work.
    // Refresh with an already-completed join is a safe no-op for join/charge; ticket poll is read-only.
    this.claimJoinEndpointGuardForPurchase();

    // Handle case when syndicateObj is not available
    if (!this.syndicateObj) {
      const encryptedId = this.paymentService.salesJourneyCustomerPurchaseId$.getValue();
      if (!encryptedId) {
        this.enterPostPurchaseTerminalError(
          "[fetchTicketData] missing salesJourneyCustomerPurchaseId; cannot poll payment status"
        );
        return;
      }
      let pollSettled = false;
      const markPollSettled = () => {
        pollSettled = true;
      };
      // Poll immediately, then every 1s — overall capped at syndicateRequestPollMaxMs.
      // Transient HTTP errors skip the tick; terminal comes from timeout or definitive status.
      timer(0, this.digitThousand).pipe(
        exhaustMap(() =>
          this.paymentService.getCustomerPurchaseDetailsFromEncryptedCpId(encryptedId).pipe(
            catchError((err) => {
              this.authService.errorHandlerLogs(
                "[fetchTicketData] transient payment status poll error (will retry):",
                err
              );
              return EMPTY;
            })
          )
        ),
        filter((data: Data) => {
          const id = data?.api_response?.response?.encrypt_syndicate_id;
          const status = data?.processed_status;
          // Only settle on failure or a ready syndicate id — never on pending/undefined id.
          if (status === -1) {
            return true;
          }
          return status === 2 && !!id && id !== "0";
        }),
        take(1),
        timeout({ first: this.syndicateRequestPollMaxMs }),
        switchMap((data: Data) => {
          if (!this.isTicketOwnerCurrent()) return EMPTY;
          const encrypt_syndicate_id = data?.api_response?.response?.encrypt_syndicate_id;
          const processed_status = data?.processed_status;

          if (processed_status === -1) {
            markPollSettled();
            // Payment failed after claim — unlock so a later retry/refresh can claim again.
            this.releaseJoinEndpointClaimForPurchase();
            this.clearLoadingUiForTerminalFailure();
            const errorMsg = data.payment_response_description
              ? data.payment_response_description
              : "Payment failed, please try again!";
            const defaultMsg = {
              message: {
                line_1: errorMsg,
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: CommonVariable.error,
              },
            };
            this.authService.showToastMessage({}, defaultMsg);
            this.modalCtrl.dismiss();
            this.router.navigate(["mainTabs/tabs/syndicate"]);
            return EMPTY;
          }

          if (processed_status === 2 && encrypt_syndicate_id && encrypt_syndicate_id !== "0") {
            // Backend confirmed purchase/join success — durable no-op for refresh / multi-click.
            this.markPostPurchaseJoinCompleted();
            this.loadSyndicateNameFromId(encrypt_syndicate_id);
            this.paymentService.emitSyndicatePurchaseComplete();
            // Trigger toast
            this.authService.getConstantsMsg("1092").then(translatedMsg => {
              if (!this.isTicketOwnerCurrent()) return;
              this.authService.showToastMessage(translatedMsg, {
                message: {
                  line_1: "Payment has been successfully processed",
                  line_2: ""
                },
                style: { icon: "tick circle success.png", type: "Success" }
              });
            });
            // Fetch base + addon tickets; priming and addon resolution handled inside updateSyndicateViewFromSyndicateId.
            return this.ticketFetchService
              .updateSyndicateViewFromSyndicateId(
                this.userId,
                encrypt_syndicate_id,
                this.syndicateDetails,
                this.WinMoreStatus,
                true,
                encryptedId
              )
              .pipe(
                filter(() => this.isTicketOwnerCurrent()),
                map((ticketRes) => {
                  if (!this.isValidTicketViewResponse(ticketRes)) {
                    throw new Error("Invalid ticket response after payment");
                  }
                  this.ticketData = ticketRes.ticketData;
                  this.onPostPurchaseTicketsReady({ autoNavigate: true });
                  markPollSettled();
                  return true;
                }),
                catchError((err) => {
                  this.authService.errorHandlerLogs(
                    "[fetchTicketData] Failed to load syndicate tickets with addons:",
                    err
                  );
                  return throwError(() => err);
                })
              );
          }

          markPollSettled();
          return EMPTY;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: () => {
          markPollSettled();
        },
        error: (err) => {
          markPollSettled();
          this.enterPostPurchaseTerminalError("[fetchTicketData] payment status poll failed or timed out:", err);
        },
        complete: () => {
          if (!pollSettled) {
            this.enterPostPurchaseTerminalError(
              "[fetchTicketData] payment status poll completed without syndicate id"
            );
          }
        },
      });
      return;
    }

    // Handle case when syndicateObj has pwa_syndicate_request_id — poll until id is ready.
    if (this.syndicateObj?.pwa_syndicate_request_id) {
      const requestId = this.syndicateObj.pwa_syndicate_request_id;
      let pollSettled = false;
      const markPollSettled = () => {
        pollSettled = true;
      };
      timer(0, this.digitThousand)
        .pipe(
          exhaustMap(() =>
            this.storeService.getSyndicateRequestId(requestId).pipe(
              catchError((err) => {
                this.authService.errorHandlerLogs(
                  "[fetchTicketData] transient syndicate request poll error (will retry):",
                  err
                );
                return EMPTY;
              })
            )
          ),
          map((resData: Data) => resData?.encrypt_syndicate_id as string | undefined),
          filter((encryptId): encryptId is string => !!encryptId && encryptId !== "0"),
          take(1),
          timeout({ first: this.syndicateRequestPollMaxMs }),
          switchMap((encryptId) => {
            if (!this.isTicketOwnerCurrent()) return EMPTY;
            if (this.syndicateObj) {
              this.syndicateObj.encrypt_syndicate_id = encryptId;
            }
            this.markPostPurchaseJoinCompleted();
            return this.ticketFetchService.getTicketData(this.userId, encryptId, this.syndicateDetails).pipe(
              take(1),
              filter(() => this.isTicketOwnerCurrent()),
              map((ticketRes) => {
                this.ticketData = ticketRes;
                this.loadingService.dismiss();
                this.onPostPurchaseTicketsReady({ autoNavigate: true });
                markPollSettled();
                return true;
              })
            );
          }),
          catchError((err) => {
            this.authService.errorHandlerLogs("[fetchTicketData] Error resolving syndicate request:", err);
            return throwError(() => err);
          }),
          takeUntil(this.unsubscribe$)
        )
        .subscribe({
          next: () => {
            markPollSettled();
          },
          error: (error) => {
            markPollSettled();
            this.enterPostPurchaseTerminalError(
              "[fetchTicketData] syndicate request poll failed or timed out:",
              error
            );
          },
          complete: () => {
            if (!pollSettled) {
              this.enterPostPurchaseTerminalError(
                "[fetchTicketData] syndicate request poll completed without encrypt id"
              );
            }
          },
        });
      return;
    }

    // syndicateObj present but no request id — try encrypt id directly if available.
    const encryptId = this.syndicateObj?.encrypt_syndicate_id;
    if (encryptId && encryptId !== "0") {
      this.ticketFetchService
        .getTicketData(this.userId, encryptId, this.syndicateDetails)
        .pipe(take(1), takeUntil(this.unsubscribe$))
        .subscribe({
          next: (ticketRes) => {
            if (!this.isTicketOwnerCurrent()) return;
            this.ticketData = ticketRes;
            this.loadingService.dismiss();
            this.onPostPurchaseTicketsReady({ autoNavigate: true });
          },
          error: (err) => {
            this.enterPostPurchaseTerminalError("[fetchTicketData] Error fetching syndicate product:", err);
          },
        });
      return;
    }

    this.enterPostPurchaseTerminalError(
      "[fetchTicketData] syndicateObj missing pwa_syndicate_request_id and encrypt_syndicate_id"
    );
  }



  /**
   * One absolute 15s deadline for the entire post-payment ticket UI:
   * CP/syndicate id resolution + base products + add-on/upsell append.
   * Starts when the ticket UI opens and must never restart when a handle arrives.
   */
  private bindPostPaymentTicketDeadline(): void {
    if (!this.isTicketOwnerCurrent()) return;
    this.paymentService.startPostPaymentTicketDeadline();
    this.paymentService
      .postPaymentDeadline$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (!this.baseOfferTicketGenerated) {
          this.redirectToSyndicateGenerating();
          return;
        }
        // Base ticket already shown — keep modal; add-on wait stops via postPaymentStop$.
        this.paymentLogService.updateLogToLocal({
          deadlineElapsedWithTickets: true,
          allExpectedDisplayed: this.areAllExpectedPostPaymentProductsDisplayed(),
        });
      });
  }

  private postPaymentStop$() {
    return merge(this.unsubscribe$, this.paymentService.postPaymentDeadline$());
  }

  private getBaseCustomerPurchaseId(): string | null {
    return (
      this.paymentService.salesJourneyCustomerPurchaseId$.getValue() ||
      this.paymentService.cashPurchaseCustomerPurchaseId$.getValue() ||
      null
    );
  }

  /** Prefer the CP ID captured at post-payment for the active flow to avoid stale cross-flow IDs. */
  private resolveBaseCustomerPurchaseIdForAddons(): string | null {
    if (this.postPaymentCustomerPurchaseId) {
      return this.postPaymentCustomerPurchaseId;
    }
    if (this.isSalesJourney) {
      return this.paymentService.salesJourneyCustomerPurchaseId$.getValue() || null;
    }
    if (this.isCashPurchase || this.isAddCardCashPurchase) {
      return this.paymentService.cashPurchaseCustomerPurchaseId$.getValue() || null;
    }
    return null;
  }

  private resolvePostPaymentCustomerPurchaseId$(addOnOfferCpId?: string) {
    if (addOnOfferCpId) {
      return of(addOnOfferCpId);
    }
    if (this.isSalesJourney) {
      return this.paymentService.salesJourneyCustomerPurchaseId$;
    }
    if (this.isCashPurchase) {
      return this.paymentService.cashPurchaseCustomerPurchaseId$;
    }
    if (this.isAddCardCashPurchase) {
      const existing = this.getBaseCustomerPurchaseId();
      if (existing) {
        return of(existing);
      }
      return merge(
        this.paymentService.cashPurchaseCustomerPurchaseId$.pipe(
          distinctUntilChanged(),
          filter((id): id is string => !!id)
        ),
        this.paymentService.salesJourneyCustomerPurchaseId$.pipe(
          distinctUntilChanged(),
          filter((id): id is string => !!id)
        )
      );
    }
    return of(null);
  }

  private trackCustomerPurchaseDocument(addOnOfferCpId?: string) {
    this.loadingService?.dismiss();
    this.customerPurchaseSubscription?.unsubscribe();

    const stop$ = this.postPaymentStop$();
    const captureAddons = !addOnOfferCpId;

    this.customerPurchaseSubscription = this.resolvePostPaymentCustomerPurchaseId$(addOnOfferCpId)
      .pipe(
        filter((customerPurchaseId): customerPurchaseId is string => !!customerPurchaseId),
        take(1),
        switchMap((customerPurchaseId) => {
          if (!addOnOfferCpId) {
            this.postPaymentCustomerPurchaseId = customerPurchaseId;
            this.paymentLogService.updateLogToLocal({ customerPurchaseId });
          }
          return this.waitForSyndicateIdForPurchase(customerPurchaseId, captureAddons, stop$);
        }),
        takeUntil(stop$),
        catchError((err) => {
          this.authService.errorHandlerLogs("[trackCustomerPurchaseDocument]", err);
          return of(null);
        })
      )
      .subscribe((syndicateId) => {
        if (syndicateId) {
          this.applySyndicateTicketView(syndicateId);
        }
      });
  }

  private waitForSyndicateIdForPurchase(
    customerPurchaseId: string,
    captureAddons: boolean,
    stop$: Observable<unknown>
  ): Observable<string> {
    const isValidId = (syndicateId: string | null): syndicateId is string =>
      !!syndicateId && syndicateId !== "0";

    const salesSyndicateId = this.paymentService.salesJournyPaymentDetails$.value;
    const addCardSyndicateId = this.paymentService.cashPurchaseAddCardSyndicateId$.value;
    const existing = isValidId(salesSyndicateId)
      ? salesSyndicateId
      : isValidId(addCardSyndicateId)
        ? addCardSyndicateId
        : null;
    if (existing) {
      return of(existing);
    }

    const fromSalesJourney$ = this.paymentService.salesJournyPaymentDetails$.pipe(
      filter(isValidId)
    );
    const fromAddCard$ = this.paymentService.cashPurchaseAddCardSyndicateId$.pipe(
      filter(isValidId)
    );

    const fromWatch$ = this.paymentService.watchCustomerPurchaseSnapshot(customerPurchaseId).pipe(
      tap((data) => {
        if (!this.isTicketOwnerCurrent() || !data) {
          return;
        }
        this.paymentService.getCustomerPurchaseDetails$.next(data);
        if (captureAddons) {
          const addonCpIds = this.ticketFetchService.getAddonCpIdsFromSnapshot(data);
          if (addonCpIds.length) {
            addonCpIds.forEach((cpId) => this.expectedAddonCpIds.add(cpId));
            this.paymentService.addOnOffersCustomerPurchaseIds$.next(addonCpIds);
          }
        }
      }),
      map((data) => data?.api_response?.response?.encrypt_syndicate_id ?? null),
      filter(isValidId),
      catchError((err) => {
        this.authService.errorHandlerLogs(
          "[waitForSyndicateIdForPurchase] Snapshot watch failed:",
          err
        );
        return EMPTY;
      })
    );

    const fromPoll$ = timer(0, this.digitThousand).pipe(
      switchMap(() =>
        this.ticketFetchService
          .getSyndicateIdFromCustomerPurchase(this.userId, customerPurchaseId, captureAddons)
          .pipe(
            catchError((err) => {
              this.authService.errorHandlerLogs(
                "[waitForSyndicateIdForPurchase] Failed to read customer purchase:",
                err
              );
              return of(null);
            })
          )
      ),
      filter(isValidId)
    );

    return merge(fromSalesJourney$, fromAddCard$, fromWatch$, fromPoll$).pipe(
      take(1),
      takeUntil(stop$)
    );
  }

  private trackCustomerPurchaseDocumentFromAddCard() {
    this.addCardCustomerPurchaseSubscription?.unsubscribe();

    this.addCardCustomerPurchaseSubscription = this.ticketFetchService
      .trackCustomerPurchaseDocumentFromAddCard()
      .pipe(
        takeUntil(this.postPaymentStop$()),
        catchError((err) => {
          this.authService.errorHandlerLogs(
            "[trackCustomerPurchaseDocumentFromAddCard] Failed to resolve syndicate ID:",
            err
          );
          return EMPTY;
        })
      )
      .subscribe({
        next: (syndicateId) => this.applySyndicateTicketView(syndicateId),
      });
  }

  updateSyndicateViewFromSyndicateId(syndicateId: string) {
    this.applySyndicateTicketView(syndicateId);
  }

  private applySyndicateTicketView(syndicateId: string) {
    if (!this.isTicketOwnerCurrent() || !syndicateId || syndicateId === "0") {
      return;
    }

    // Avoid restarting product wait if we already showed the base ticket for this load.
    if (this.baseOfferTicketGenerated) {
      return;
    }

    this.ticketViewUpdateSubscription?.unsubscribe();

    // Shared absolute deadline — remaining time only; never restarts the 15s clock.
    const stop$ = this.postPaymentStop$();

    this.loadSyndicateNameFromId(syndicateId);

    // Listener + bounded poll; emits only when products exist (empty collection never marks visible).
    this.ticketViewUpdateSubscription = this.ticketFetchService
      .waitForTicketProducts(this.userId, syndicateId, stop$)
      .pipe(
        filter(() => this.isTicketOwnerCurrent()),
        map((products) => this.buildTicketViewResponse(syndicateId, products)),
        filter((ticketRes) => this.isValidTicketViewResponse(ticketRes)),
        take(1),
        takeUntil(stop$),
        catchError((err) => {
          this.authService.errorHandlerLogs(
            "[applySyndicateTicketView] Failed to load syndicate tickets:",
            err
          );
          return EMPTY;
        })
      )
      .subscribe({
        next: (ticketRes) => {
          this.applyTicketViewResponse(syndicateId, ticketRes, false);
          this.startAddonAppendAfterBase();
        },
      });
  }

  private buildTicketViewResponse(
    syndicateId: string,
    products: Data[]
  ): { syndicateId: string; ticketData: Data; isWinMore: boolean } {
    const syndicateTicketData = { product: products } as Data;
    const prepared = this.ticketFetchService.prepareTicketsData(
      syndicateTicketData,
      this.syndicateDetails
    );
    prepared?.product?.forEach((product: Data) => {
      product.encrypt_syndicate_id = syndicateId;
      product.isWinMore = this.WinMoreStatus === true;
    });
    return {
      syndicateId,
      ticketData: prepared,
      isWinMore: prepared?.product?.[0]?.isWinMore === true,
    };
  }

  /**
   * After the base ticket is on screen, append add-on/upsell tickets as they resolve.
   * Bounded by the same absolute 15s deadline as base loading (postPaymentStop$).
   * Expected products = base ticket + every add-on CP id discovered on the purchase doc
   * before the deadline. Once the deadline fires we stop waiting; if the base ticket is
   * already visible we keep the modal open rather than redirecting away from it.
   */
  private startAddonAppendAfterBase(): void {
    if (!(this.isSalesJourney || this.isCashPurchase || this.isAddCardCashPurchase)) {
      return;
    }

    this.addonAppendSubscription?.unsubscribe();
    const addonStop$ = this.postPaymentStop$();

    this.addonAppendSubscription = this.resolveBaseCustomerPurchaseIdForAddons$()
      .pipe(
        filter((baseCpId): baseCpId is string => !!baseCpId),
        take(1),
        switchMap((baseCpId) => {
          this.postPaymentCustomerPurchaseId = baseCpId;
          return this.ticketFetchService.watchAddonCpIds(this.userId, baseCpId, addonStop$);
        }),
        takeUntil(addonStop$),
        catchError((err) => {
          this.authService.errorHandlerLogs("[startAddonAppendAfterBase]", err);
          return EMPTY;
        })
      )
      .subscribe((cpIds) => {
        cpIds.forEach((cpId) => {
          this.expectedAddonCpIds.add(cpId);
          this.loadAndAppendAddonProducts(cpId, addonStop$);
        });
      });
  }

  /**
   * True when the base ticket is shown and every add-on/upsell CP id discovered so far
   * has been loaded (or none were discovered). Discovery itself is bounded by the
   * shared deadline — late add_on fields after expiry are intentionally ignored.
   */
  private areAllExpectedPostPaymentProductsDisplayed(): boolean {
    if (!this.baseOfferTicketGenerated) {
      return false;
    }
    for (const cpId of this.expectedAddonCpIds) {
      if (!this.loadedAddonCpIds.has(cpId)) {
        return false;
      }
    }
    return true;
  }

  private resolveBaseCustomerPurchaseIdForAddons$(): Observable<string | null> {
    const immediate = this.resolveBaseCustomerPurchaseIdForAddons();
    if (immediate) {
      return of(immediate);
    }

    return merge(
      this.paymentService.salesJourneyCustomerPurchaseId$,
      this.paymentService.cashPurchaseCustomerPurchaseId$
    ).pipe(
      filter((id): id is string => !!id),
      take(1),
      takeUntil(this.unsubscribe$),
      defaultIfEmpty(null as string | null)
    );
  }

  private loadAndAppendAddonProducts(cpId: string, stop$: Observable<unknown>): void {
    if (!cpId || this.loadedAddonCpIds.has(cpId) || this.loadingAddonCpIds.has(cpId)) {
      return;
    }
    this.loadingAddonCpIds.add(cpId);

    this.ticketFetchService
      .watchAddonTicketProducts(this.userId, cpId, this.syndicateDetails, stop$)
      .pipe(
        take(1),
        takeUntil(stop$),
        catchError((err) => {
          this.authService.errorHandlerLogs("[loadAndAppendAddonProducts]", err);
          return of([] as Data[]);
        })
      )
      .subscribe((products) => {
        this.loadingAddonCpIds.delete(cpId);
        if (!products?.length) {
          return;
        }
        this.loadedAddonCpIds.add(cpId);
        this.appendTicketProducts(products);
      });
  }

  private appendTicketProducts(products: Data[]): void {
    if (!this.isTicketOwnerCurrent() || !products?.length || !this.ticketData?.product) {
      return;
    }

    const existingKeys = new Set(
      this.ticketData.product.map(
        (product: Data) => `${product?.id ?? ""}|${product?.encrypt_syndicate_id ?? ""}`
      )
    );
    const newProducts = products.filter(
      (product: Data) =>
        !existingKeys.has(`${product?.id ?? ""}|${product?.encrypt_syndicate_id ?? ""}`)
    );
    if (!newProducts.length) {
      return;
    }

    this.ticketData = {
      ...this.ticketData,
      product: [...this.ticketData.product, ...newProducts],
    };
    this.onTicketDataLoaded();
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  private applyTicketViewResponse(
    syndicateId: string,
    ticketRes: { syndicateId: string; ticketData: Data; isWinMore: boolean },
    includeAddons: boolean
  ): void {
    if (!this.isTicketOwnerCurrent() || !this.isValidTicketViewResponse(ticketRes)) {
      return;
    }

    this.ticketData = ticketRes.ticketData;
    this.baseOfferTicketGenerated = true;
    this.paymentService.markPostPaymentTicketsVisible();
    if (includeAddons) {
      this.paymentService.addOnOffersCustomerPurchaseIds$.next(null);
    }

    if (ticketRes.ticketData.product[0]?.isWinMore) {
      this.openWinMorePopup();
    }

    this.onPostPurchaseTicketsReady({
      // Keep ticket preview for sales/cash; credit fetchTicketData path auto-navigates.
      autoNavigate: false,
    });
    this.paymentLogService.updateLogToLocal({ syndicateId });
  }

  private isValidTicketViewResponse(
    ticketRes: { ticketData?: Data } | null | undefined
  ): boolean {
    const products = ticketRes?.ticketData?.product;
    return Array.isArray(products) && products.length > 0;
  }

  private handlePostPaymentTicketFailure(context: string, err: unknown): void {
    this.authService.errorHandlerLogs(`${context} Error:`, err);
    this.redirectToSyndicateGenerating();
  }

  private redirectToSyndicateGenerating(): void {
    if (!this.isTicketOwnerCurrent() || this.postPaymentRedirected || this.baseOfferTicketGenerated) {
      return;
    }
    this.postPaymentRedirected = true;
    this.paymentLogService.updateLogToLocal({ timedOut: true });
    this.clearPostPurchaseSlowTimer();
    this.clearProgressInterval();
    this.dataFetched = true;
    this.showProgressBar = false;
    this.showAlmostThere = false;
    this.showLoader.set(false);
    this.changeDetectorRef.detectChanges();

    this.showAlmostThere = true;
    this.showTimerError = false;
    this.almostThereText = "Preparing your tickets...";
    this.changeDetectorRef.detectChanges();
    this.continueToSyndicateWhenReady();

    // This advisory write is independent of navigation and never submits payment.
    try {
      this.paymentService
        .setSyndicatePending()
        .pipe(take(1), timeout(5000), takeUntil(this.unsubscribe$))
        .subscribe({
          error: (error) => {
            if (!this.isDestroyed) this.authService.errorHandlerLogs("setSyndicatePending on ticket fallback:", error);
          },
        });
    } catch (error) {
      this.authService.errorHandlerLogs("setSyndicatePending on ticket fallback:", error);
    }
  }

  private continueToSyndicateWhenReady(): void {
    this.ticketRedirectRecovery?.unsubscribe();
    const recovery = new Subscription();
    this.ticketRedirectRecovery = recovery;
    const ownerUserId = this.userId || getAuth().currentUser?.uid;
    const target = "mainTabs/tabs/syndicate";
    const ownModal = this.elRef?.nativeElement?.closest?.("ion-modal") as HTMLIonModalElement | undefined;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;
    let deadline: ReturnType<typeof setTimeout> | undefined;
    let attempts = 0;
    let navigating = false;
    const isCurrent = () => !recovery.closed && this.isTicketOwnerCurrent() && !!ownerUserId &&
      getAuth().currentUser?.uid === ownerUserId;
    recovery.add(() => { clearTimeout(retryTimer); clearTimeout(deadline); });
    recovery.add(this.unsubscribe$.subscribe(() => recovery.unsubscribe()));
    recovery.add(this.router.events?.subscribe((event) => {
      if (event instanceof NavigationStart && event.url.replace(/^\//, "").split(/[?#]/)[0] !== target) recovery.unsubscribe();
    }));
    recovery.add(onAuthStateChanged(getAuth(), (user) => {
      if (!user || user.isAnonymous || user.uid !== ownerUserId) recovery.unsubscribe();
    }, () => recovery.unsubscribe()));

    let removalStarted = false;
    const removeOwnModal = () => {
      if (!ownModal || removalStarted) return;
      removalStarted = true;
      // Routing already succeeded. A stalled Ionic dismissal cannot block it,
      // and scoped removal can never dismiss a replacement page's modal.
      const removalTimer = setTimeout(() => ownModal.remove(), 1000);
      try {
        void ownModal.dismiss().catch(() => undefined).then(() => {
          clearTimeout(removalTimer);
          ownModal.remove();
        });
      } catch { clearTimeout(removalTimer); ownModal.remove(); }
    };
    recovery.add(removeOwnModal);
    const navigate = async () => {
      if (!isCurrent() || navigating) return;
      clearTimeout(retryTimer);
      navigating = true;
      try {
        const accepted = await Promise.race([
          this.router.navigateByUrl(target),
          new Promise<boolean>(resolve => { deadline = setTimeout(() => resolve(false), 10000); }),
        ]);
        if (!isCurrent()) return;
        if (!accepted) throw new Error("Paid ticket continuation was not accepted");
        recovery.unsubscribe();
      } catch (error) {
        if (!isCurrent()) return;
        this.authService.errorHandlerLogs("Paid ticket continuation is preparing:", error);
        retryTimer = setTimeout(navigate, ++attempts <= 2 ? 2000 : 10000);
      } finally {
        clearTimeout(deadline);
        navigating = false;
      }
    };
    void navigate();
  }

  ionViewWillLeave(): void {
    this.ticketRedirectRecovery?.unsubscribe();
  }

  ngOnDestroy(): void {
    const mayClearPurchaseState = this.isTicketOwnerCurrent();
    this.ticketOwnerAuthUnsubscribe?.();
    this.ticketOwnerAuthUnsubscribe = undefined;
    this.isDestroyed = true;
    this.ticketRedirectRecovery?.unsubscribe();
    this.clearPostPurchaseSlowTimer();
    this.clearProgressInterval();
    this.clearProgressCompleteTimer();
    this.clearNavigationTimers();
    this.globalProsubSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.customerPurchaseSubscription?.unsubscribe();
    this.addCardCustomerPurchaseSubscription?.unsubscribe();
    this.ticketViewUpdateSubscription?.unsubscribe();
    this.addonAppendSubscription?.unsubscribe();
    if (mayClearPurchaseState) {
      this.paymentService?.cashPurchaseCustomerPurchaseId$?.next(null);
      this.paymentService?.cashPurchaseAddCardSyndicateId$?.next(null);
      this.paymentService?.salesJourneyCustomerPurchaseId$?.next(null);
    }
    this.ticketFetchService.destroy();
    this.changeDetectorRef.detach();
  }

  enableLuckyNum() {
    try {
      this.startip.toggle();
      var toolTipVisible = this.startip._isTooltipVisible();
      if (toolTipVisible) {
        this.startip.hide();
        this.showStatusCard = true;
      } else {
        this.startip.show();
        this.showStatusCard = false;
        setTimeout(() => {
          this.startip.hide();
          if (this.syndicateDetails?.active_product_count) {
            this.luckyNumberFeatureDisplay = true;
            this.showStatusCard = true;
            this.changeDetectorRef.detectChanges();
          }
        }, 3000);
      }
      this.changeDetectorRef.detectChanges();
    } catch (err) {
      return err;
    }
  }

  enableGoldRing() {
    if (!this.goldRingRemainingData) return;
    this.goldRingFeatureDisplay = true;
    this.showGrStatusCard = true;
  }

  ionViewWillEnter() {
    this.showSlides = true;
    this.changeDetectorRef.detectChanges();
  }

  getSelectedTicketAfterSave(tktNum, tktRow, tktId, nextDrawDate, alreadySelectedObj) {
    try {
      if (alreadySelectedObj) {
        if (alreadySelectedObj[nextDrawDate]?.claimed) return false;
      }
      let albhaData = this.alphabeticOrder(tktRow);
      if (this.selectedNumbers.hasOwnProperty(tktId)) {
        if (this.selectedNumbers[tktId][albhaData]?.some((e) => e === tktNum)) return true;
        else return false;
      } else return false;
    } catch (err) {
      return false;
    }
  }

  getSelectedGoldRings(alphabet, ticket) {
    try {
      if (
        !this.goldRingFeatureDisplay ||
        this.syndicateDetails?.syndicate_type !== "Ongoing" ||
        this.syndicateDetails?.active_status !== "running" ||
        ticket?.isExpired
      )
        return;
      const productId = ticket?.id;
      if (!ticket || this.alreadySelectedGRLines?.[productId]?.includes(alphabet)) return;
      if (ticket?.gold_ring && ticket?.gold_ring?.lines) {
        if (!ticket?.gold_ring?.lines?.includes(alphabet)) {
          //select
          if (!this.displayGoldRingRemainingData) return;
          ticket.gold_ring.lines.push(alphabet);
          this.displayGoldRingRemainingData--;
          this.totalGoldRingSelectedCount++;
          this.goldRingInUseCount++;

          ticket["selectedGoldRingCount"] = this.totalGoldRingSelectedCount; //To enable/disable confirm button
          if (this.selectedGRAry.hasOwnProperty(productId)) {
            this.selectedGRAry[productId].push({ [alphabet]: ticket?.[alphabet] });
          } else {
            this.selectedGRAry[productId] = [];
            this.selectedGRAry[productId].push({ [alphabet]: ticket?.[alphabet] });
          }
          this.grDrawDate[productId] = ticket?.next_draw_date;
        } else {
          // deselect
          ticket.gold_ring.lines = ticket.gold_ring.lines.filter((x) => x !== alphabet);
          this.displayGoldRingRemainingData++;
          this.totalGoldRingSelectedCount--;
          this.goldRingInUseCount--;
          ticket["selectedGoldRingCount"] = this.totalGoldRingSelectedCount;

          this.selectedGRAry[productId] = this.selectedGRAry[productId]?.filter((x) => !x.hasOwnProperty(alphabet));
          if (!this.selectedGRAry[productId].length) delete this.selectedGRAry[productId];
          delete this.grDrawDate[productId];
        }
      } else {
        //Add new gold_ring object
        ticket["gold_ring"] = {};
        ticket["gold_ring"]["lines"] = [alphabet];
        this.displayGoldRingRemainingData--;
        this.totalGoldRingSelectedCount++;
        this.goldRingInUseCount++;
        ticket["selectedGoldRingCount"] = this.totalGoldRingSelectedCount;
        this.selectedGRAry[productId] = [];
        this.selectedGRAry[productId].push({ [alphabet]: ticket?.[alphabet] }); //selectedGRAry is to update confirmed GR Lines
        this.grDrawDate[productId] = ticket?.next_draw_date;
      }
      this.disabledGRStyle = this.displayGoldRingRemainingData ? "" : "disabled-color";
    } catch (err) {
      return err;
    }
  }

  isGRAlreadySelected(albhaData, productIndex) {
    /* let goldLine = false;
    this.ticketData?.product.forEach((product) => {
      if (!product.hasOwnProperty("gold_ring") || !product?.gold_ring.hasOwnProperty("lines")) return goldLine;
      goldLine = this.alreadySelectedGRLines.includes(albhaData) ? true : false;
    });
    return goldLine; */
    let goldLine = false;
    const product = this.ticketData?.product[productIndex];
    if (!product || !product.hasOwnProperty("gold_ring") || !product.gold_ring.hasOwnProperty("lines")) return goldLine;
    goldLine = product.gold_ring.lines.includes(albhaData) ? true : false;
    return goldLine;
  }

  disableGRLine(albhaData, productIndex) {
    try {
      if (!this.displayGoldRingRemainingData && !this.isGRAlreadySelected(albhaData, productIndex)) return true;
      else return false;
    } catch (err) {
      return false;
    }
  }

  isNumberAlreadySelected(productIndex, tktRow, tktNum) {
    try {
      const albhaData = this.alphabeticOrder(tktRow);
      const nextDrawDate: Date = this.ticketData?.product[productIndex]?.next_draw_date
        ? this.ticketData?.product[productIndex]?.next_draw_date?.toDate()
        : new Date();
      const drawSelected = this.datepipe.transform(nextDrawDate, "yyyy-MM-dd");
      if (!this.ticketData?.product[productIndex].hasOwnProperty("selected_numbers")) return false;
      if (this.ticketData?.product[productIndex]?.selected_numbers[drawSelected][albhaData]?.some((e) => e === tktNum))
        return true;
      else return false;
    } catch (err) {
      return false;
    }
  }

  getSelectedTicket(event, num, albha, productIndex, tktid) {
    try {
      if (this.ticketData?.product[productIndex]?.isExpired || this.isNumberAlreadySelected(productIndex, albha, num))
        return;
      event.stopPropagation();
      if (!(event?.target instanceof HTMLInputElement)) {
        return;
      }

      let albhaData = this.alphabeticOrder(albha);
      if (num && albhaData) {
        let className = "color-bg";
        var numAry = [];
        if (event && event?.target?.classList?.contains(className)) {
          if (event && !event?.target && !event?.target?.classList) {
            event?.target?.classList?.remove(className);
          }
          numAry = this.selectedNumbers[tktid][albhaData];
          if (numAry.length === 1) {
            delete this.selectedNumbers[tktid][albhaData];
            if (isEmpty(this.selectedNumbers[tktid])) delete this.selectedNumbers[tktid];
          } else {
            const index = numAry?.indexOf(num);
            if (index !== -1) numAry.splice(index, 1);
          }
          this.displayRemainingData++;
          this.totalSelectedCount--;
          this.inUseCount--;
        } else {
          if (!this.displayRemainingData) return;
          if (event && event?.target && event?.target?.classList) {
            event?.target?.classList?.add(className);
          }
          if (!this.selectedNumbers.hasOwnProperty(tktid)) {
            this.selectedNumbers[tktid] = {};
          }
          if (this.selectedNumbers[tktid].hasOwnProperty(albhaData)) {
            numAry = this.selectedNumbers[tktid][albhaData];
            numAry.push(num);
            this.selectedNumbers[tktid][albhaData] = numAry;
          } else {
            numAry.push(num);
            this.selectedNumbers[tktid][albhaData] = numAry;
          }
          this.displayRemainingData--;
          this.totalSelectedCount++;
          this.inUseCount++;
        }
        let tktSelCount = 0;
        let tktSelAlrdCount = this.ticketData?.product[productIndex]?.alreadySelectedCount
          ? this.ticketData?.product[productIndex]?.alreadySelectedCount
          : 0;
        for (const selKey in this.selectedNumbers[tktid]) {
          tktSelCount += this.selectedNumbers[tktid][selKey]?.length;
        }
        Object.assign(this.ticketData?.product[productIndex], {
          selectedCount: tktSelCount - tktSelAlrdCount,
        });
        this.disabledLNStyle = this.displayRemainingData ? "" : "disabled-color";
      }
    } catch (error) {
      return false;
    }
  } // getSelectedTicket end

  confirmGoldRingSelection() {
    try {
      const reqObj = {
        next_draw_date: this.grDrawDate,
        encrypted_syndicate_id: this.syndicateDetails?.encrypted_id,
        gold_ring_request_data: this.selectedGRAry,
        total_selected_count: this.totalGoldRingSelectedCount ?? 0,
      };
      this.luckyNumberService.confirmGoldRingSelection(reqObj);
      if (this.matDialog.openDialogs.length === 0) {
        this.matDialog.open(SelectedGoldRingLockedComponent, {
          panelClass: "lucky-number-popup",
          minHeight: "60vh",
          width: "85vw",
          data: this.userId,
        });
      }
    } catch (error) {
      return false;
    }
  }

  openConfirmPopup() {
    try {
      let selectedNumbersLength = Object.keys(this.selectedNumbers).length;
      if (selectedNumbersLength) {
        if (this.matDialog.openDialogs.length === 0) {
          const modal = this.matDialog.open(ConfirmSelectedLuckyNumbersComponent, {
            panelClass: "lucky-number-popup",
            minHeight: "60vh",
            width: "85vw",
            data: {
              syndicateId: this.syndicateDetails?.encrypted_id,
              ticketDetails: this.ticketData,
              selectedLuckyNumbers: this.selectedNumbers,
              balanceDetails: {
                selectedLNCount: this.inUseCount,
                remainingCount: this.displayRemainingData,
              },
            },
          });
        }
      } else {
        //this.snackService.openSnackBar("There is an issue with Lucky Numbers, Please try again", "", "Error", "Error");
        /*  const msg = this.translatedToastMsg?.["1058"]?.[this.selectedLanguage];
         this.authService.showToast(msg ? msg : "There is an issue with Lucky Numbers, Please try again", "Error", ""); */
        this.authService
          .getConstantsMsg("1058")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "There is an issue with Lucky Numbers, Please try again",
                line_2: "",
              },
              style: {
                type: "error",
                icon: "tick circle error.svg",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
      }
    } catch (error) {
      return false;
    }
  }

  lostLuckyNumbers() {
    this.luckyNumberService.hideAvailableLn.next(true);
    this.luckyNumberService.hideAvailableGR.next(true);
    if (!this.totalSelectedCount && !this.totalGoldRingSelectedCount) {
      this.goBack();
    } else {
      if (this.matDialog.openDialogs.length === 0 && this.totalSelectedCount) {
        const modal = this.matDialog.open(SelectedLuckyNumbersLostComponent, {
          panelClass: "lucky-number-popup",
          minHeight: "60vh",
          width: "85vw",
          data: this.userId,
        });
      }
      if (this.matDialog.openDialogs.length === 0 && this.totalGoldRingSelectedCount) {
        this.matDialog.open(SelectedGoldRingLostComponent, {
          panelClass: "lucky-number-popup",
          minHeight: "60vh",
          width: "85vw",
          data: this.userId,
        });
      }
    }
  }

  getTicketData() {
    if (!this.isTicketOwnerCurrent()) return;
    const postPurchase = this.isPostPurchaseFlow();
    // Avoid bare in-progress animation + enabled Proceed while tickets are still loading.
    const useOverlayLoader = postPurchase || this.syndicateTicketSource !== "syndicateTab";
    if (postPurchase) {
      this.beginPostPurchaseLoadingUi();
    } else if (useOverlayLoader) {
      this.beginOverlayLoadingUi();
    } else {
      this.loadingService.present();
    }

    const baseCpId = this.resolveBaseCustomerPurchaseIdForAddons();
    const mergeAddonsFromPurchase =
      (this.isSalesJourney || this.isCashPurchase || this.isAddCardCashPurchase) &&
      !!baseCpId;

    if (!mergeAddonsFromPurchase) {
      this.ticketFetchService
        .getTicketData(this.userId, this.syndicateDetails?.encrypted_id, this.syndicateDetails)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (ticketRes) => {
            if (!this.isTicketOwnerCurrent()) return;
            this.ticketData = ticketRes;
            this.loadingService.dismiss();
            if (postPurchase) {
              this.onPostPurchaseTicketsReady({ autoNavigate: !!this.syndicateObj });
            } else if (useOverlayLoader) {
              this.clearPostPurchaseSlowTimer();
              this.clearProgressInterval();
              this.dataFetched = true;
              this.showLoader.set(false);
              this.showProgressBar = false;
              this.showAlmostThere = false;
              this.onTicketDataLoaded();
              this.changeDetectorRef.detectChanges();
            } else {
              this.onTicketDataLoaded();
              this.changeDetectorRef.detectChanges();
            }
          },
          (err) => {
            this.loadingService.dismiss();
            this.authService.errorHandlerLogs("[getTicketData] Error fetching syndicate tickets:", err);
            if (useOverlayLoader) {
              this.clearLoadingUiForTerminalFailure();
              this.showTimerError = true;
              this.changeDetectorRef.detectChanges();
            }
          }
        );
      return;
    }

    this.ticketFetchService
      .updateSyndicateViewFromSyndicateId(
        this.userId,
        this.syndicateDetails?.encrypted_id,
        this.syndicateDetails,
        this.WinMoreStatus,
        true,
        baseCpId
      )
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((err) => {
          this.authService.errorHandlerLogs(
            "[getTicketData] Failed to load syndicate tickets with addons:",
            err
          );
          return throwError(() => err);
        })
      )
      .subscribe({
        next: (ticketRes) => {
          if (!this.isTicketOwnerCurrent()) return;
          if (!this.isValidTicketViewResponse(ticketRes)) {
            this.loadingService.dismiss();
            this.handlePostPaymentTicketFailure(
              "[getTicketData]",
              new Error("Missing ticket products in syndicate response")
            );
            return;
          }
          this.ticketData = ticketRes.ticketData;
          this.loadingService.dismiss();
          this.onPostPurchaseTicketsReady({ autoNavigate: false });
        },
        error: (err) => {
          this.loadingService.dismiss();
          this.clearLoadingUiForTerminalFailure();
          this.showTimerError = true;
          this.changeDetectorRef.detectChanges();
          this.authService.errorHandlerLogs("[getTicketData] Error loading syndicate tickets:", err);
        },
      });
  }
  
  switchMode(flipState: boolean) {
    const digitSixHundred = 600;
    const digitFourFifty = 450;
    if (flipState) {
      this.showFlip = "start";
      setTimeout(() => {
        this.showLines = false;
        this.changeDetectorRef.detectChanges();
      }, digitSixHundred);
    } else {
      this.showFlip = "end";
      setTimeout(() => {
        this.showLines = true;
        this.changeDetectorRef.detectChanges();
      }, digitFourFifty);
    }
  }

  alphabeticOrder(val) {
    return excelLabelForIndex(val);
  }

  goBack() {
    this.modalCtrl.dismiss().catch((err) => {
      return err;
    });
  }

  getSliderOptions(ticketArray: Data) {
    if (ticketArray?.length === 1) {
      this.ticketSlider["centeredSlides"] = true;
    }
    return this.ticketSlider;
  }

  async setTicket(ticketImageUrl: string) {
    const modal = this.modalCtrl.create({
      component: SyndicateTicketPreviewComponent,
      componentProps: { ticketImageUrl },
      cssClass: "ticket-preview",
      showBackdrop: true,
    });
    (await modal).present();
  }

  getCurrencyValue(currency, gameRepoService) {
    return new Promise((resolve, reject) => {
      gameRepoService
        .getDVCurrency(currency)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  previewTicket() {
    /* Preview ticket Image when
    user click on camera Icon and Image Rendered on DOM*/
    if (this.ticketImageURL !== "") {
      this.filePreview.preview();
    }
  }

  openHelpTab() {
    this.openInAppBrowser("https://help.lotto-social.com/hc/en-us/?app=1");
  }

  async openInAppBrowser(urlData: string) {
    if (Browser) {
      await Browser.open({ url: urlData });
      window.open(urlData);
    }
  }

  viewPlayers(i) {
    //check if the ticket is of rapidfire
    if (this.realname == "RapidFire") {
      // Define the constant for the tooltip prefix
      const TOOLTIP_PREFIX = "#tooltip-";
      // Find the tooltip element based on the given index (i)
      const tooltipElement = this.elRef?.nativeElement?.querySelector(TOOLTIP_PREFIX + i);
      if (tooltipElement) {
        tooltipElement.style.display = "block";
        this.showToolTip = true;
        this.AuthPartialRegService.coachMarkData()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res: Data) => {
              let coachMarkDescription = res?.content?.[this.languageCode]?.description || "";
              if (coachMarkDescription) {
                const currencyMatches = coachMarkDescription.match(/\[currency_beauty:(\d+)\]/g);
                if (currencyMatches && currencyMatches.length > 0) {
                  const promises = currencyMatches.map((match) => {
                    return this.getCurrencyValue(match, this.gameRepoService)
                      .then((result) => {
                        return result;
                      })
                      .catch((error) => {
                        return error; // Handle errors gracefully by providing a default value
                      });
                  });

                  Promise.all(promises)
                    .then((results) => {
                      currencyMatches.forEach((match, index) => {
                        coachMarkDescription = coachMarkDescription.replace(match, results[index]);
                      });
                      if (res && res.content && coachMarkDescription) {
                        const customizeObject = {
                          title: res?.content?.[this.languageCode]?.title,
                          description: coachMarkDescription,
                        };
                        this.coachMarkData$.next(customizeObject);
                      } else {
                        throw new Error("Error: Data is null or empty.");
                      }
                    })
                    .catch((error) => {
                      return error;
                    });
                } else {
                  // Handle the case when there are no currency matches
                  // For example, set coachMarkDescription to some default value
                  const customizeObject = {
                    title: res?.content?.[this.languageCode]?.title,
                    description: res?.content?.[this.languageCode]?.description,
                  };
                  this.coachMarkData$.next(customizeObject);
                }
              } else {
                // Handle the case when there are no currency matches
                // For example, set coachMarkDescription to some default value
                const customizeObject = {
                  title: res?.content?.[this.languageCode]?.title,
                  description: res?.content?.[this.languageCode]?.description,
                };
                this.coachMarkData$.next(customizeObject);
              }
            },
            (error) => {
              return error;
            }
          );
        setTimeout(() => {
          tooltipElement.style.display = "none";
        }, this.timer);
      }
    } else {
      try {
        this.dotAnimation = true;
        this.syndicateService
          .viewPlayersCount(this.syndicateDetails)
          ?.pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (res: Data) => {
              this.viewText = false;
              this.dotAnimation = false;
              if (res && res?.response && res?.response?.status === "SUCCESS") {
                this.syndicateCount = res?.response?.syndicate_size;
              } else {
                this.syndicateCount = "0";
              }
              // As we have used onPush change detection strategy, we need to update the view
              this.changeDetectorRef.detectChanges();
            },
            (err) => {
              return err;
            }
          );
      } catch (e) {
        return e;
      }
    }
  }

  isRaffleAvailable(index: number) {
    return this.ticketData?.product[index]?.ticketLines.some((x) => x?.raffle?.length);
  }

  goToSyndicateTab() {
    // Idempotent: first click / auto-nav wins; refreshes or rapid taps are no-ops.
    if (!this.tryBeginProceedNavigation()) {
      return;
    }
    this.performProceedNavigation();
  }

  loaderGoToSyndicateTab() {
    if (!this.tryBeginProceedNavigation()) {
      return;
    }
    this.modalCtrl
      .dismiss()
      .then(() => {
        this.router.navigate(["mainTabs/tabs/syndicate"]).catch((navErr) => {
          this.proceedNavigating = false;
          this.hasAutoNavigated = false;
          return navErr;
        });
      })
      .catch((err) => {
        this.proceedNavigating = false;
        this.hasAutoNavigated = false;
        return err;
      });
  }

  slideChanged() {
    if (!this.syndicateTicketsSlider) return;
    this.updateSyndicateNameForActiveSlide();
    this.syndicateTicketsSlider?.swiperRef?.update();
  }

  openSyndicates() {
    this.loadingService.present();
    this.router.navigateByUrl("/mainTabs/tabs/syndicate");
  }
  private snapShotData(actions: import("@angular/fire/compat/firestore").DocumentChangeAction<unknown>[]): Data[] {
    return actions?.map((a) => {
      const data = a?.payload?.doc?.data() as Data;
      const id = a?.payload?.doc?.id;
      return { id, ...data };
    });
  }
  async onLoopComplete() {
    await setTimeout(() => {
      this.showAnim.set(false);
    }, 500);
  }
  onTouchTickits() {
    this.showAnim.set(false);
  }
  slidePrev() {
    this.syndicateTicketsSlider?.swiperRef?.slidePrev(this.navigationSpeed);
  }
  slideNext() {
    this.syndicateTicketsSlider?.swiperRef?.slideNext(this.navigationSpeed);
  }
  getMonths() {
    const translationKeys = [
      "dynamic_value.January",
      "dynamic_value.February",
      "dynamic_value.March",
      "dynamic_value.April",
      "dynamic_value.May",
      "dynamic_value.June",
      "dynamic_value.July",
      "dynamic_value.August",
      "dynamic_value.September",
      "dynamic_value.October",
      "dynamic_value.November",
      "dynamic_value.December",
    ];
    this.translate
      .get(translationKeys)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((translation: string[]) => {
        this.ngZone.run(() => {
          this.months = translationKeys.map((key) => translation[key]);
        });
      });
  }
  translateMonth(date: Date): string {
    if (!date || !this.months) return "";
    const monthIndex = date.getMonth();
    if (monthIndex >= 0 && monthIndex < this.months.length) {
      return this.months[monthIndex];
    }
  }

  // This method has been used to open Win More Popup
  openWinMorePopup() {
    if (
      this.ticketData.product[0]?.isWinMore ||
      this.syndicateDetails?.win_more_promise_details ||
      this.iswinMoreDataFetched
    ) {
      const syndicateData = this.syndicateDetails?.win_more_promise_details
        ? this.syndicateDetails
        : this.syndicateWinMoreData[0];
      this.bottomSheet.open(WinMorePopupComponent, {
        panelClass: "win-popup",
        data: syndicateData, // pass syndicate details to the popup
      });
    } else {
      // This tost message is used to show error
      const translatedMsg = {
        message: {
          line_1: "Win more Status not found",
          line_2: "",
        },
        style: {
          duration: 2000,
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      const defaultMsg = {
        message: {
          line_1: "Win more Status not found",
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      this.authService.showToastMessage(translatedMsg, defaultMsg);
    }
  }
}
